//@flow

import env from '../../../../environment';
import {
  deleteCreator,
  getCreator,
  postCreator,
  putCreator,
} from '../../../../http';

export const endpoints = Object.freeze({
  LIST_SHIPPING_METHODS: `${env.baseApiUrl}/im/admin/delivery/shipping-method`,
  UPDATE_SHIPPING_METHOD_ENABLED: `${env.baseApiUrl}/im/admin/delivery/shipping-method`,
  UPDATE_SHIPPING_METHOD_ACTIVE: `${env.baseApiUrl}/im/admin/delivery/shipping-method`,
  SAVE_SHIPPING_ESTANDAR_RATE: `${env.baseApiUrl}/im/admin/delivery/shipping-method`,
  SAVE_SHIPPING_ADVANCED_RATE: `${env.baseApiUrl}/im/admin/delivery/shipping-method`,
  SAVE_SHIPPING_COUNTRIES: `${env.baseApiUrl}/im/admin/delivery/shipping-method`,
  // LIST_SHIPPING_ESTANDAR: `${env.baseApiUrl}/im/admin/delivery/shipping-method`,
  // FLAT RATE
  GET_FLAT_RATE: `${env.baseApiUrl}/im/admin/delivery/shipping-method/flat-rate/:flatRateId`,
  SAVE_FLAT_RATE: `${env.baseApiUrl}/im/admin/delivery/shipping-method/flat-rate`,
  UPDATE_FLAT_RATE: `${env.baseApiUrl}/im/admin/delivery/shipping-method/flat-rate/:flatRateId`,
  DELETE_FLAT_RATE: `${env.baseApiUrl}/im/admin/delivery/shipping-method/flat-rate/:flatRateId`,
  // SHIPPING ADVANCED
  SAVE_SHIPPING_ADVANCED: `${env.baseApiUrl}/im/admin/delivery/shipping-method/admin`,
  GET_SHIPPING_ADVANCED: `${env.baseApiUrl}/im/admin/delivery/shipping-method/admin/:shippingMethodId`,
  UPDATE_SHIPPING_ADVANCED: `${env.baseApiUrl}/im/admin/delivery/shipping-method/admin/:shippingMethodId`,
  DELETE_SHIPPING_ADVANCED: `${env.baseApiUrl}/im/admin/delivery/shipping-method/admin/:shippingMethodId`,
  // SHIPPING STANDARD
  SAVE_SHIPPING_STANDARD: `${env.baseApiUrl}/im/admin/delivery/shipping-method/standard`,
  GET_SHIPPING_STANDARD: `${env.baseApiUrl}/im/admin/delivery/shipping-method/standard/:shippingMethodId`,
  UPDATE_SHIPPING_STANDARD: `${env.baseApiUrl}/im/admin/delivery/shipping-method/standard/:shippingMethodId`,
  DELETE_SHIPPING_STANDARD: `${env.baseApiUrl}/im/admin/delivery/shipping-method/standard/:shippingMethodId`,
});

export const getShippingMethodApi = getCreator(endpoints.LIST_SHIPPING_METHODS);
export const updatedShippingMethodEnabledApi = putCreator(
  endpoints.UPDATE_SHIPPING_METHOD_ENABLED
);
export const addShippingCountriesApi = putCreator(
  endpoints.SAVE_SHIPPING_COUNTRIES
);
export const updateShippingMethodActiveApi = putCreator(
  endpoints.UPDATE_SHIPPING_METHOD_ACTIVE
);

// FLAT RATE
export const getFlatRateApi = getCreator(endpoints.GET_FLAT_RATE);
export const saveFlatRateApi = postCreator(endpoints.SAVE_FLAT_RATE);
export const updateFlatRateApi = putCreator(endpoints.UPDATE_FLAT_RATE);
export const deleteFlatRateApi = deleteCreator(endpoints.DELETE_FLAT_RATE);

// SHIPPING ADVANCED
export const saveShippingAdvancedApi = postCreator(
  endpoints.SAVE_SHIPPING_ADVANCED
);
export const getShippingAdvancedApi = getCreator(
  endpoints.GET_SHIPPING_ADVANCED
);
export const updateShippingAdvancedApi = putCreator(
  endpoints.UPDATE_SHIPPING_ADVANCED
);
export const deleteShippingAdvancedApi = deleteCreator(
  endpoints.DELETE_SHIPPING_ADVANCED
);

// SHIPPING STANDARD
export const saveShippingStandardApi = postCreator(
  endpoints.SAVE_SHIPPING_STANDARD
);
export const getShippingStandardApi = getCreator(
  endpoints.GET_SHIPPING_STANDARD
);
export const updateShippingStandardApi = putCreator(
  endpoints.UPDATE_SHIPPING_STANDARD
);
export const deleteShippingStandardApi = deleteCreator(
  endpoints.DELETE_SHIPPING_STANDARD
);
